/** Generate variable name (key) from question text: lowercase, spaces to underscores, alphanumeric only. */
export function questionToVariableName(question: string): string {
    const slug = (question || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '')
        .slice(0, 50);
    return slug || 'field';
}

export interface FlowStep {
    id: string;
    question: string;
    variable: string;
    type: 'text' | 'email' | 'phone' | 'selection';
    options?: string[]; // For selection type
}

export interface FlowAction {
    id: string;
    type: 'email' | 'webhook' | 'notification';
    recipient_email?: string;
    subject?: string;
    webhook_url?: string;
    payload_template?: string;
    completion_message_success?: string;
    completion_message_failure?: string;
}

export interface Flow {
    id: string;
    name: string;
    description?: string;
    trigger_keywords: string[];
    is_active: boolean;
    steps: FlowStep[];
    actions: FlowAction[];
    /** @deprecated Use completion_message_success / completion_message_failure */
    completion_message?: string;
    completion_message_success?: string;
    completion_message_failure?: string;
}
